<div class="main">
  <app-navbar></app-navbar>
  <!-- <main [@routeAnimations]="prepareRoute(outlet)">
        <router-outlet #outlet="outlet"></router-outlet>
    </main> -->
  <div class="container-fluid">
    <div class="row">
      <section class="section" id="home-view">
        <app-home></app-home>
      </section>
    </div>
    <div class="row">
      <section class="section" id="about-view">
        <app-about></app-about>
      </section>
    </div>
    <div class="row">
      <section class="section" id="experience-view">
        <app-experience></app-experience>
      </section>
    </div>
    <div class="row">
      <section class="section" id="skills-view">
        <app-skills></app-skills>
      </section>
    </div>
    <div class="row">
      <section class="section" id="education-view">
        <app-education></app-education>
      </section>
    </div>
    <div class="row">
      <section class="section" id="contact-view">
        <app-contact></app-contact>
      </section>
    </div>
  </div>
  <app-footer></app-footer>
</div>
